export default __webpack_public_path__ + "static/media/party.1c20c4c5.png";